export class BorrowerTermsController {
  static $inject = ["$routeParams", "$scope", "$location"];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    private $location: ng.ILocationService,
  ) {}
}
